<template>
    <div class="flex rounded-md ring-1 ring-gray-100 overflow-hidden transition-all duration-150 lg:hover:ring-green-600 mb-3 md:mb-0">
        <label
            :class="[cursorPointer&&'cursor-pointer' ]"
            class="flex flex-col"
        >
            <div class="py-3 px-4 bg-green-100 text-lg font-600 text-gray-900">
                <slot name="input" />
            </div>
            <div class="py-3 px-4 border-t text-base xs:text-lg flex-grow flex flex-col justify-between transition-all duration-150 ring-gray-100">
                <slot name="content" />
            </div>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        cursorPointer: {
            type: Boolean,
            default: true
        },
    },
};
</script>
